import { render, staticRenderFns } from "./kraken.vue?vue&type=template&id=19cfcbff&scoped=true"
import script from "./kraken.vue?vue&type=script&lang=js"
export * from "./kraken.vue?vue&type=script&lang=js"
import style0 from "./kraken.vue?vue&type=style&index=0&id=19cfcbff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cfcbff",
  null
  
)

export default component.exports